export enum ConsumerProfilePostSubmissionConfigPage {
  Approval = 'approval',
  Decline = 'decline', 
  MerchantLocator ='merchantLocator'
} 